import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgGift = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 25 25"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12.75 7.937H8.702a2.25 2.25 0 1 1 0-4.5c3.15 0 4.05 4.5 4.05 4.5M12.752 7.937h4.05a2.25 2.25 0 1 0 0-4.5c-3.15 0-4.05 4.5-4.05 4.5"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.754 7.964h13.884c1.038 0 1.878.841 1.878 1.878v.816c0 .98-.794 1.772-1.771 1.772H5.86a1.88 1.88 0 0 1-1.878-1.877v-.818c0-.978.793-1.77 1.772-1.77M19.973 12.457v6.508a2.47 2.47 0 0 1-2.47 2.47H7.999a2.47 2.47 0 0 1-2.47-2.47v-6.508M12.75 21.437v-8.902"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgGift);
export default ForwardRef;
